// src/pages/pedidos/index.js
import Pedidos from './Pedidos'
import PedidosHistorial from './PedidosHistorial'
import NuevoPedido from './NuevoPedido'
import VerPedido from './VerPedido'
import EditarPedido from './EditarPedido'
import EliminarPedido from './EliminarPedido'
import CancelarPedido from './CancelarPedido'

export {
	Pedidos,
	PedidosHistorial,
	NuevoPedido,
	VerPedido,
	EditarPedido,
	EliminarPedido,
	CancelarPedido
}

export default Pedidos